import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaLock } from "react-icons/fa";
import { handleReportNavigation } from '../../../utils/mobileNavigation';

function ReportsTable({ data }) {
  const navigate = useNavigate();

  const getRecords = () => {
    const reports = data;

    return reports.map((report, index) => (
      <tr key={index}>
        <td data-label='S NO.'>{index + 1}</td>
        <td data-label='FARMER NAME'>{report.farmer_name || 'N/A'}</td>
        <td data-label='SAMPLE ID'>{report.sample_id}</td>
        <td data-label='REPORT ID'>{report.report_id}</td>
        {/* <td data-label='PREVIOUS CROP'>{index}</td>
        <td data-label='NEXT CROP'>{index}</td> */}
        <td data-label='DEVICE ID'>{report.device_id}</td>
        <td data-label='REPORT TIME'>
          {new Date(Date.parse(report.created_at)).toDateString()}
        </td>
        <td>
        {report.is_locked ? (
            <FaLock color='red' size={20} />
          ) : (
            <Button
            variant="warning"
            onClick={() => handleReportNavigation(navigate, `/admin/report/${report.report_id}`)}
          >
            View
          </Button>
          )}
        </td>
      </tr>
    ));
  };

  return (
    <table
      className={`table table-striped text-center table-borderless ${
        data.length > 1 ? 'align-middle' : ''
      }`}
    >
      <thead className='table-dark align-top'>
        <tr>
          <th>S NO.</th>
          <th>FARMER NAME</th>
          <th>SAMPLE ID </th>
          <th>REPORT ID</th>
          {/* <th>PREVIOUS CROP</th>
          <th>NEXT CROP</th> */}
          <th>DEVICE ID</th>
          <th>REPORT TIME</th>
          {/* <th>STATUS</th> */}
          <th>ACTIONS</th>
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          getRecords()
        ) : (
          <tr>
            <td className='no-entries' colSpan='10'>
              No Entries Found..
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default ReportsTable;
